var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowOnActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    x: 7.5,
    y: 8.5,
    fill: "#4092f5",
    stroke: "#4092f5",
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 5,
    x: 7.5,
    y: 16.5,
    fill: "#4092f5",
    stroke: "#4092f5",
    rx: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8 12h2v1H8zM10 10h2v3h-2zM12 11h2v2h-2zM20 20h2v1h-2zM18 18h2v3h-2zM16 20h2v1h-2zM14 19h2v2h-2zM12 18h2v3h-2zM10 18h2v3h-2zM8 19h2v2H8zM14 10h2v3h-2zM16 12h2v1h-2zM18 11h2v2h-2zM20 11h2v2h-2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowOnActive);
export default __webpack_public_path__ + "static/media/low-on-active.c2bd17da9c1e1c57e111677926c4537a.svg";
export { ForwardRef as ReactComponent };